import { StoreEditOutlineIcon } from './StoreEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 02C64DBE-89C9-4190-80FF-1EB52327BFB5
 * name store-edit-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-edit-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Edit / Modify 
 */
export const ShopEditOutlineIcon = StoreEditOutlineIcon;
export default ShopEditOutlineIcon